import EventsHandler from './events-handler'

class EventsClickHandler extends EventsHandler {
    constructor () {
        super('[data-dl-event]:not(form)', 'click')
    }
}

export default EventsClickHandler